import React, { Component } from 'react'
import { narrativeHistoryReset } from '../actions/narrative'
import { connect } from 'react-redux'

class DraftDocuments extends Component {
  onDocumentSelect = id => {
    this.props.narrativeHistoryReset()
    this.props.history.push({
      pathname: `/edit/${id}/`,
    })
  }

  render() {
    let table = []
    table.push(
      <thead key='header'>
        <tr key='header_tr' className='item item-name-header'>
          <th className='item-name'>Version</th>
          <th className='item-name'>Last Updated On</th>
          <th className='item-name'>Last Updated By</th>
          <th className='item-name' style={{ width: '20px' }}>
            Editable
          </th>
        </tr>
      </thead>
    )

    table.push(
      <tbody key='body'>
        {this.props.narratives.map((narrative, i) => {
          return (
            <tr
              className={
                ['published', 'duplicated', 'superseded'].includes(narrative.state_name) ? 'item item-approved' : 'item'
              }
              key={i}
              data-testid={`history${i}`}
              onClick={() => {
                this.onDocumentSelect(narrative.id)
              }}>
              <td className='item-name'>
                {narrative.revision}.{narrative.revision_decimal_part} - {narrative.state_title}
              </td>
              <td className='item-name'>{narrative.updated_display}</td>
              <td className='item-name'>{narrative.last_edited_by}</td>
              <td className='item-name'>
                {narrative.user_can_save || narrative.user_can_comment ? (
                  <span className={'dot-ok'}>&#10003;</span>
                ) : (
                  <span className={'dot-ko'}>&#10005;</span>
                )}
              </td>
            </tr>
          )
        })}
      </tbody>
    )

    return (
      <div>
        {this.props.narratives.length > 0 && (
          <div>
            <h3>
              {this.props.narratives[0].country_name} ({this.props.narratives[0].csp_country_key}) -{' '}
              {this.props.narratives[0].year}
            </h3>
            <p style={{ margin: '10px 0 5px 0' }}>Click on a COMP to open the document: </p>
            <table className='landing--form-menu'>{table}</table>
          </div>
        )}
      </div>
    )
  }
}

const mapDispatchToProps = { narrativeHistoryReset }

DraftDocuments = connect(
  null,
  mapDispatchToProps
)(DraftDocuments)

export default DraftDocuments
